window.addEventListener("load", () => {
    document.querySelectorAll(".tx-wp-forms").forEach((element) => {
        WpFormHandler.initOnContainer(element);

        element.querySelectorAll('.fieldwrap.form-group:has(select.form-control)').forEach((fieldWrap) => {
            setInterval(() => {
                fieldWrap.querySelector('label')?.classList.add('animated-label-up');
            }, 10);
        });
    });
});